import { render, staticRenderFns } from "./ProfilePage.vue?vue&type=template&id=c8ae92f4"
import script from "./ProfilePage.js?v=1?vue&type=script&lang=js&external"
export * from "./ProfilePage.js?v=1?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports